import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton, MatFabButton } from '@angular/material/button';
import { MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { LowLevelApi } from '@app/shared/services/state/low-level-api.service';
import { RouterService } from '../../../services/router.service';
import { AbstractReactiveDialogComponent } from '../reactive-dialog/base/abstract-reactive-dialog-component';

@Component({
  selector:    'app-gsm-abort-dialog',
  templateUrl: './gsm-abort-dialog.component.html',
  styleUrls:   ['./gsm-abort-dialog.component.scss'],
  standalone:  true,
  imports:     [
    NgIf,
    MatDialogTitle,
    MatIcon,
    MatFabButton,
    MatTooltip,
    MatButton
  ]
})
export class GsmAbortDialogComponent extends AbstractReactiveDialogComponent<any, any, string> {

  private llapi = inject(LowLevelApi);
  routerService = inject(RouterService);

  constructor() {
    super();
  }

  onAccept() {
    this.dialogRef.close({status: 'success'});
    this.clearProcessDraft();
  }

  onSaveClick() {
    this.dialogRef.close({context: 'save'});
  }

  private clearProcessDraft() {
    this.llapi.resetValues([
      'gsm.processInstanceId',
      'gsm.lastEditTimestamp',
      'gsm.selectedTaskId',
      'gsm.currentFormInput',
      'gsm.currentHistoryFormInput'
    ]);
  }
}
